import esTranslations from './es.json';
import enTranslations from './en.json';
import ptTranslations from './pt.json';
import itTranslations from './it.json';
import frTranslations from './fr.json';
import deTranslations from './de.json';
import caTranslations from './ca.json';

export const i18nResources = {
	en: { translation: enTranslations },
	es: { translation: esTranslations },
	pt: { translation: ptTranslations },
	it: { translation: itTranslations },
	fr: { translation: frTranslations },
	de: { translation: deTranslations },
	ca: { translation: caTranslations },
} as const;

export const SUPPORTED_LANGUAGES = Object.keys(i18nResources);
export const DEFAULT_LANGUAGE = 'es';
